// extracted by mini-css-extract-plugin
export default {"headline":"newsletters-subscribe_headline__hXuro","emailInput":"newsletters-subscribe_emailInput__qKp2e"};